import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ModuleWorkload"
const debug = false

export class ModuleWorkload extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.WORKLOAD, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Workload"
        this.description                = "The Workload module offers a comprehensive view of team capacity and task allocation. This feature enables users to efficiently manage workload distribution, ensuring balanced assignments and optimal resource utilization across projects. With customizable views and analytics, the Workload module empowers teams to identify potential bottlenecks, allocate tasks effectively, and maintain productivity."
        this.svgIcon                    = "isvg-view-my-workload"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Time and Resources"
        this.settingsUrl                = "settings/workload"
        this.parentSection              = SettingsParentSection.TIME

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.WORKLOAD
        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}